import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import MobileHeader from "../../components/header/MobileHeader";
import LoginHeader from "../../components/header/LoginHeader";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import Breadcrumb from "../../components/breadcrumb";
import LoginMobileHeader from "../../components/header/LoginMobileHeader";
import InstituteMobileHeader from "../../components/header/InstituteMobileHeader";
import CRMobileHeader from "../../components/header/CRMobileHeader";
import InstituteHeader from "../../components/header/InstituteHeader";
import CRHeader from "../../components/header/CRHeader";
import NonLoginHeader from "../../components/header/NonLoginHeader";
import UpdateCandidatebyInstityte from "../../khojpages/UpdateCandidatebyInstitute/UpdateCandidatebyInstitute";
import EditCandidByInst from "./EditCandidByInst";
import { Helmet } from "react-helmet";

EditProfile.propTypes = {};

function EditProfile(props) {
  const [isShowMobile, setShowMobile] = useState(false);

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);
  const module = localStorage.getItem("Module");
  return (
    <>
     <Helmet>
				<title>Institute/Candidate/Update | Jobkikhoj</title>
				<meta name="description" content=" " />
				<meta name="keywords" content=" " />
				<meta property="og:title" content="Institute/Candidate/Update | Jobkikhoj " />
				<meta property="og:description" content="" />
				<meta property="og:url" content="https://jobkikhoj.com" />
			</Helmet>
      {module === "Candidate" ? (
        <LoginMobileHeader handleMobile={handleMobile} />
      ) : module === "Institution" ? (
        <InstituteMobileHeader handleMobile={handleMobile} />
      ) : module === "Company" ? (
        <CRMobileHeader handleMobile={handleMobile} />
      ) : module === "Recruiter" ? (
        <CRMobileHeader handleMobile={handleMobile} />
      ) : (
        <MobileHeader handleMobile={handleMobile} />
      )}
      {module === "Candidate" ? (
        <LoginHeader clname="manageBatch" handleMobile={handleMobile} />
      ) : module === "Institution" ? (
        <InstituteHeader clname="manageBatch" handleMobile={handleMobile} />
      ) : module === "Company" ? (
        <CRHeader clname="manageBatch" handleMobile={handleMobile} />
      ) : module === "Recruiter" ? (
        <CRHeader clname="manageBatch" handleMobile={handleMobile} />
      ) : (
        <NonLoginHeader clname="manageBatch" handleMobile={handleMobile} />
      )}
      {/* <Breadcrumb title="Approval Process" className="breadcrumb-section" /> */}

      <div className="pt-70">
        {/* <UpdateCandidatebyInstityte /> */}
        <EditCandidByInst />
        <Footer />
        <Gotop />
      </div>
    </>
  );
}

export default EditProfile;
